<template>

  <select><slot></slot></select>

</template>

<script>
  import TagService from '../services/tag'

  export default {
    name: 'selectize',
    data: () => ({
       initialize:false
    }),
    props: ['options','showMe', 'value','runnerid','isRunnerTag','isRaceTag','raceId','isPromoTag','promoCodeId','isPromoCodeTag'],
    mounted: function () {
      var vm = this
      var opt = $.extend({},$(this.$el).data())
      if (this.options != null)
        opt.options = this.options
        if(!this.isPromoCodeTag){
          opt.plugins= ['remove_button']
        }
        opt.create= function(input, callback){
          var tagData = {
              "name": input
            }
            TagService.createTag(tagData).then((response)=>{
              console.log("createTag---",response.data)
              callback(response.data)
            })         
        }

        opt.onItemAdd=(value, $item) => { 
         
            if(this.initialize && this.isRunnerTag) {
              TagService.addRunnerTag(this.runnerid,value).then((response)=>{
                console.log("addRunnerTag---",value)
              })
            }else if(this.initialize && this.isRaceTag){
               TagService.addRaceTag(this.raceId,value).then((response)=>{
                console.log("addRaceTag---",value)
              })
            } else if(this.initialize && this.isPromoTag){
              //console.log("addPromoTag---",this.promoCodeId,"---isPromoTag---",this.isPromoTag)
               TagService.addPromoTag(this.promoCodeId,value).then((response)=>{
                console.log("addPromoCodeTag---",value)
              })
            }                          
        }
        opt.onItemRemove=(value)=>{
          if(this.isRunnerTag){
            TagService.removeRunnerTags(this.runnerid,value).then((response)=>{
                console.log("removeRunnerTags---",value)
              })
          }else if(this.isRaceTag){
            TagService.removeRaceTag(this.raceId,value).then((response)=>{
                console.log("removeRaceTag---",value)
              })
          } else if(this.isPromoTag){
            TagService.removePromoTag(this.promoCodeId,value).then((response)=>{
                console.log("removePromoTag---",value)
              })
          } 
        }        

      this.sel = $(this.$el).selectize(opt)
        .on("change",function(){
            vm.$emit('input', vm.sel.getValue())
          })[0].selectize
      this.sel.setValue(this.value,true)

      if(this.isPromoCodeTag){
        this.sel.lock()
        //this.sel.disable()
      }    

    },
    watch: {
      value: function (newVal,oldVal) {
      //console.log("---newVal---",newVal,"--oldVal---",oldVal)
        //console.log("newVallength--",newVal.length)
        //var newValLength = newVal.length
        //var oldValLength = oldVal.length
        // if(newValLength >= oldValLength){
        //    console.log("adddddd")
        // }else{
        //   console.log("remove")
        // }

        //this.sel.setValue(newVal,true)
        //console.log("value---",this.value)


        if(!this.initialize){
          this.sel.setValue(newVal,true)
          this.initialize = true
        }

      },
      showMe:function(){
        if(!this.showMe){
          this.initialize = false
        }
      },
      options: function (options) {
          var val = this.sel.getValue()
          this.sel.clearOptions()
          this.sel.addOption(options)
          this.sel.refreshOptions(false)
          this.sel.setValue(val)
      },

    },
    destroyed: function () {
      this.sel.destroy()
    }

    
  }

//   var vm = new Vue({
//   el: '#el',
//   template: '#demo-template',
//       methods:{
//       addOption:function(){
// 				this.options.push({id:this.cpt,text:"opt " + this.cpt})
//         this.cpt++
//       },
//       changeText : function(){
//       	//this.maxOptionText = "dfsdfsf"
//       	this.selected=[4]
//       }
//     },
//   data: {
//     selected: [3],
//     cpt: 8,
//     maxOptionText : "test",
//     options: [
//        { "id": 1, "text": "Hello" }, { "id": 2, "text": "World" }, { "id": 3, "text": "opt 3" }, { "id": 4, "text": "opt 4" }, { "id": 5, "text": "opt 5" }, { "id": 6, "text": "opt 6" }, { "id": 7, "text": "opt 7" }, { "id": 8, "text": "opt 8" }
//     ]
//   }
// })
</script>



// WEBPACK FOOTER //
// Selectize.vue?1e5e14a8